<script setup></script>

<template>
    <div class="loading flex flex-col items-center justify-center gap-4">
        <svg
            class="loading--spinner"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g class="loading--base">
                <path
                    d="M37.1637 1.51901C34.2877 0.533012 31.2033 -0.00095892 28.0001 -0.00095892C24.7968 -0.00095892 21.7124 0.533012 18.8364 1.51901L20.872 7.38086C23.1019 6.61637 25.4988 6.20001 28.0001 6.20001C30.5013 6.20001 32.8982 6.61637 35.1281 7.38086L37.1637 1.51901Z"
                />
                <path
                    d="M53.1998 15.6204C50.4362 10.0464 45.8355 5.5199 40.1701 2.80085L37.418 8.35166C41.8249 10.4667 45.4082 13.9923 47.558 18.3281L53.1998 15.6204Z"
                />
                <path
                    d="M49.799 28.0004C49.799 30.5017 49.3827 32.8986 48.6182 35.1285L54.48 37.1641C55.466 34.288 56 31.2037 56 28.0004C56 24.7972 55.466 21.7128 54.48 18.8368L48.6182 20.8724C49.3827 23.1023 49.799 25.4992 49.799 28.0004Z"
                />
                <path
                    d="M40.1701 53.1992C45.8355 50.4356 50.4362 45.8349 53.1998 40.1696L47.558 37.4174C45.4082 41.8243 41.8249 45.4077 37.418 47.5574L40.1701 53.1992Z"
                />
                <path
                    d="M18.8363 54.481C21.7123 55.467 24.7967 56.001 27.9999 56.001C31.2032 56.001 34.2876 55.467 37.1636 54.481L35.128 48.6191C32.8981 49.3836 30.5012 49.8 27.9999 49.8C25.4987 49.8 23.1018 49.3836 20.8719 48.6191L18.8363 54.481Z"
                />
                <path
                    d="M2.80021 40.1701C5.56383 45.8355 10.1645 50.4362 15.8299 53.1998L18.582 47.558C14.1751 45.4082 10.5918 41.8249 8.44202 37.418L2.80021 40.1701Z"
                />
                <path
                    d="M6.20099 27.9996C6.20099 25.4983 6.61735 23.1014 7.38184 20.8715L1.51998 18.8359C0.533988 21.712 1.7643e-05 24.7963 1.7643e-05 27.9996C1.7643e-05 31.2028 0.533989 34.2872 1.51998 37.1632L7.38184 35.1276C6.61735 32.8977 6.20099 30.5008 6.20099 27.9996Z"
                />
                <path
                    d="M15.8299 2.80078C10.1645 5.51983 5.56383 10.0463 2.80021 15.6203L8.44202 18.3281C10.5918 13.9922 14.1751 10.4667 18.582 8.35159L15.8299 2.80078Z"
                />
            </g>
            <g class="loading--pulse">
                <path
                    d="M37.1637 1.51901C34.2877 0.533012 31.2033 -0.00095892 28.0001 -0.00095892C24.7968 -0.00095892 21.7124 0.533012 18.8364 1.51901L20.872 7.38086C23.1019 6.61637 25.4988 6.20001 28.0001 6.20001C30.5013 6.20001 32.8982 6.61637 35.1281 7.38086L37.1637 1.51901Z"
                />
                <path
                    d="M53.1998 15.6204C50.4362 10.0464 45.8355 5.5199 40.1701 2.80085L37.418 8.35166C41.8249 10.4667 45.4082 13.9923 47.558 18.3281L53.1998 15.6204Z"
                />
                <path
                    d="M49.799 28.0004C49.799 30.5017 49.3827 32.8986 48.6182 35.1285L54.48 37.1641C55.466 34.288 56 31.2037 56 28.0004C56 24.7972 55.466 21.7128 54.48 18.8368L48.6182 20.8724C49.3827 23.1023 49.799 25.4992 49.799 28.0004Z"
                />
                <path
                    d="M40.1701 53.1992C45.8355 50.4356 50.4362 45.8349 53.1998 40.1696L47.558 37.4174C45.4082 41.8243 41.8249 45.4077 37.418 47.5574L40.1701 53.1992Z"
                />
                <path
                    d="M18.8363 54.481C21.7123 55.467 24.7967 56.001 27.9999 56.001C31.2032 56.001 34.2876 55.467 37.1636 54.481L35.128 48.6191C32.8981 49.3836 30.5012 49.8 27.9999 49.8C25.4987 49.8 23.1018 49.3836 20.8719 48.6191L18.8363 54.481Z"
                />
                <path
                    d="M2.80021 40.1701C5.56383 45.8355 10.1645 50.4362 15.8299 53.1998L18.582 47.558C14.1751 45.4082 10.5918 41.8249 8.44202 37.418L2.80021 40.1701Z"
                />
                <path
                    d="M6.20099 27.9996C6.20099 25.4983 6.61735 23.1014 7.38184 20.8715L1.51998 18.8359C0.533988 21.712 1.7643e-05 24.7963 1.7643e-05 27.9996C1.7643e-05 31.2028 0.533989 34.2872 1.51998 37.1632L7.38184 35.1276C6.61735 32.8977 6.20099 30.5008 6.20099 27.9996Z"
                />
                <path
                    d="M15.8299 2.80078C10.1645 5.51983 5.56383 10.0463 2.80021 15.6203L8.44202 18.3281C10.5918 13.9922 14.1751 10.4667 18.582 8.35159L15.8299 2.80078Z"
                />
            </g>
        </svg>
        <p class="loading--text font-extrabold text-yellow-400 uppercase">
            Loading
        </p>
    </div>
</template>

<style scoped>
.loading {
    grid-column: 1 / -1;
    grid-row: 1 / -1;
    z-index: 10;
}

.loading--text {
    font-size: clamp(2rem, 5vw, 4rem);
    text-shadow: 0 0.140625em 0 var(--marine-base, #19233b);
    -webkit-text-stroke-width: 0.09375em;
    -webkit-text-stroke-color: var(--Marine-600, #19233b);
    paint-order: stroke fill;
}

.loading--base path {
    fill: #323b53;
}

.loading--pulse path {
    fill: #fddb32;
    animation: loading-pulse 1s linear infinite;
}

.loading--pulse path:nth-child(1) {
    animation-delay: 0s;
}
.loading--pulse path:nth-child(2) {
    animation-delay: -0.875s;
}
.loading--pulse path:nth-child(3) {
    animation-delay: -0.75s;
}
.loading--pulse path:nth-child(4) {
    animation-delay: -0.625s;
}
.loading--pulse path:nth-child(5) {
    animation-delay: -0.5s;
}
.loading--pulse path:nth-child(6) {
    animation-delay: -0.375s;
}
.loading--pulse path:nth-child(7) {
    animation-delay: -0.25s;
}
.loading--pulse path:nth-child(8) {
    animation-delay: -0.125s;
}

@keyframes loading-pulse {
    0% {
        opacity: 1;
    }
    12.5% {
        opacity: 0.7;
    }
    25% {
        opacity: 0.4;
    }
    37.5% {
        opacity: 0.2;
    }
    50% {
        opacity: 0.1;
    }
    62.5%,
    100% {
        opacity: 0;
    }
}
</style>
